/**
 * Safari reloads a collection on Back and applies the old scroll position
 * before the product grid has its real height, so the page clamps to the top.
 * Remember the position when leaving, and put it back after the grid can hold it.
 * Chrome already restores this on its own.
 */
(function () {
  var ua = navigator.userAgent || '';
  var isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isSafari = /safari/i.test(ua) && !/chrome|chromium|crios|edg|opr|android/i.test(ua);
  if (!isIOS && !isSafari) return;

  var storageKey = 'zaoud-collection-scroll:' + location.pathname + location.search;

  function readY() {
    try {
      var value = Number(sessionStorage.getItem(storageKey));
      return Number.isFinite(value) ? value : null;
    } catch (error) {
      return null;
    }
  }

  function writeY() {
    try {
      sessionStorage.setItem(storageKey, String(window.scrollY || window.pageYOffset || 0));
    } catch (error) {}
  }

  function isBackForward() {
    var entry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (entry && entry.type) return entry.type === 'back_forward';
    return performance.navigation && performance.navigation.type === 2;
  }

  function maxScroll() {
    var doc = document.documentElement;
    var body = document.body;
    var height = Math.max(doc ? doc.scrollHeight : 0, body ? body.scrollHeight : 0);
    return Math.max(0, height - window.innerHeight);
  }

  function restore(y) {
    var attempts = 0;

    function apply() {
      attempts += 1;
      window.scrollTo(0, y);
      var shortPage = maxScroll() + 8 < y;
      var missed = Math.abs((window.scrollY || window.pageYOffset || 0) - y) > 2;
      if ((shortPage || missed) && attempts < 90) requestAnimationFrame(apply);
    }

    apply();

    var grid = document.getElementById('product-grid');
    if (!grid || !window.ResizeObserver) return;

    var observer = new ResizeObserver(function () {
      window.scrollTo(0, y);
    });
    observer.observe(grid);
    window.setTimeout(function () {
      observer.disconnect();
      window.scrollTo(0, y);
    }, 2000);
  }

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  window.addEventListener('pagehide', writeY);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted && !isBackForward()) return;
    var y = readY();
    if (y == null || y < 1) return;
    restore(y);
  });
})();
